import { render, staticRenderFns } from "./RelatedMeasureCard.vue?vue&type=template&id=d3c52280&"
import script from "./RelatedMeasureCard.vue?vue&type=script&lang=js&"
export * from "./RelatedMeasureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports